export enum EntityWithContribution {
  PRODUCT,
  COMPANY,
  USER,
}
